<div id="morelikethis-tab" style="margin-top: 10px;">
    <div class="noMoreRecord" style="padding: 10px 20px; font-size: 12px;"
        *ngIf="learningCardList == undefined || (learningCardList != undefined && learningCardList.length == 0)">
        {{bs.getResource('rbkey_NoItmToDsply')}}
    </div>
    <div style="padding: 5px 10px;" *ngIf="(learningCardList != undefined && learningCardList.length > 0)">
        {{bs.getResource('rbkey_MorLkThsMsg')}}
    </div>

    <div id="carousel-container">
        <div class="owl-slider" style="display:none;">
            <div id="carousel" class="owl-carousel H_carousel">
                <ng-container *ngFor="let cardList of learningCardList">
                    <div class="item card_border">
                        <div [ngClass]="cardList | searchCard : 'iconbg'">
                            <i [ngClass]="cardList | searchCard : 'icon'"></i><span
                                class="item_label">{{cardList.ItemTypeName}}</span>
                        </div>
                        <div class="center_icon_parent">
                            <!-- <img src="{{bs.config.lmsBaseUrl + 'Control/ThumbnailGenerator.aspx?LoggedIn=0&Canvas=true&ImageWidth=198&ImageHeight=132&ImageFile=..'+ cardList.ItemThumbnailPath }}"
                                [title]="cardList.ItemName" [alt]="cardList.ItemName"
                                style="height: 132px; width: 198px; border-radius: 4px 4px 0px 0px;border-bottom:1px solid #cecbcc;"> -->

                                <img src="{{cardList.ItemThumbnailPath}}"
                                [title]="cardList.ItemName" [alt]="cardList.ItemName"
                                style="height: 132px; width: 198px; border-radius: 4px 4px 0px 0px;border-bottom:1px solid #cecbcc;">

                            <a (click)="OpenItem(cardList)" class="center_play_icon"><i
                                    class="center_play_circle"></i></a>
                        </div>
                        <div class="carousel_caption">
                            <div class="wrap_txt"> {{cardList.ItemName}} </div>
                            <div class="carousel_more color_mehroom"> {{cardList.IsMandatory?"Mandatory":"Optional"}}
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>